import { render, staticRenderFns } from "./WarningFinancialDashboard.vue?vue&type=template&id=3fdcea61&scoped=true"
import script from "./WarningFinancialDashboard.vue?vue&type=script&lang=js"
export * from "./WarningFinancialDashboard.vue?vue&type=script&lang=js"
import style0 from "./WarningFinancialDashboard.vue?vue&type=style&index=0&id=3fdcea61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdcea61",
  null
  
)

export default component.exports